module.exports = __webpack_public_path__ + "asset/img/cover-placeholder.2cdc71de3fbf873a47d106faf1eab82d.png";